import React, { useLayoutEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { InternationalPhoneInput } from '@/unlayer-tools/unlayer-form-tool/renderer/formFields/InternationalPhoneInput';
import { INTL_PHONE_INPUT_ID } from '@/hosting/ssr/islands';

const componentMap = {
    [INTL_PHONE_INPUT_ID]: InternationalPhoneInput,
};

function NotifyReady({ onReady, children }) {
    useLayoutEffect(() => {
        onReady();
    }, [onReady]);

    return children;
}

export default async function mountIslands(root = document) {
    const mounts = [];

    Object.entries(componentMap).forEach(([id, Component]) => {
        const containers = root.querySelectorAll(`[${id}]`);

        containers.forEach((container) => {
            if (container.dataset.hydrated) return;

            container.dataset.hydrated = 'true';

            const propsScript = container.querySelector('script[data-props]');
            let props;

            if (!propsScript) {
                console.warn(`[hydrate] Missing props script in ${id} container - skipping.`);

                return;
            }

            try {
                props = JSON.parse(propsScript.innerHTML);
            } catch (e) {
                console.error(`[hydrate] Failed to parse props for ${id}:`, e);

                return;
            }

            mounts.push(new Promise((resolve) => {
                container.innerHTML = '';
                createRoot(container).render(
                    <NotifyReady onReady={resolve}>
                        <Component {...props} />
                    </NotifyReady>,
                );
            }));
        });
    });

    await Promise.all(mounts);
}
